var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"newEditor",staticStyle:{"height":"200px","margin-bottom":"54px"},attrs:{"content":_vm.editorContent,"options":_vm.newOption},on:{"change":_vm.editorChange}})}
var staticRenderFns = []

export { render, staticRenderFns }